import AdminLayout from './admin'
export default AdminLayout
